
export function on($el, event, callback) {
  $el.addEventListener(event, callback, false);
}

export function off($el, event, callback) {
  $el.removeEventListener(event, callback);
}
